import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import TitleScreen from './TitleScreen';

export default class Background extends Phaser.Scene {
  static get KEY() { return 'Background'; }

  constructor() {
    super({ key: Background.KEY });
  }

  create() {
    this.background = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._Background, this).setOrigin(0);
    this.hill = ABCyaPhaser.Images.addImage(0,this.scale.height, UIAssetKeys._Hill, this).setOrigin(0,1);

    this.scene.launch(TitleScreen.KEY);
  }
}